export default __webpack_public_path__ + "static/media/cp_geo_vi.fde2519d.svg";